import { B2BColorConfig, defaultCorpColors } from "redmond";

export const colors: B2BColorConfig = defaultCorpColors;
